var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoSurfaceHabitable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.915,
    height: 28.916,
    viewBox: "0 0 28.915 28.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#616a7d;}.b{fill:none;stroke:#2c3852;stroke-width:1.5px;opacity:0.75;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M110.416,4.783A.455.455,0,0,0,110.9,4.3V1.892h.482a.455.455,0,0,0,.482-.482.455.455,0,0,0-.482-.482H110.9V-.518A.455.455,0,0,0,110.416-1a.455.455,0,0,0-.482.482V4.3A.455.455,0,0,0,110.416,4.783Z",
    transform: "translate(-103.669 1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M90.975,124.79a.4.4,0,0,0,.419-.419v-6.705h1.257a.461.461,0,0,0,.419-.251.473.473,0,0,0-.126-.461L86.617,111.3a2.876,2.876,0,0,0-3.813,0l-6.328,5.657a.5.5,0,0,0-.126.461.424.424,0,0,0,.377.251h1.257v6.705a.4.4,0,0,0,.419.419H90.975Z",
    transform: "translate(-70.273 -103.464)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M413.9,366.9h-1.446v-.482a.482.482,0,0,0-.964,0v.482h-2.41a.482.482,0,1,0,0,.964H413.9a.482.482,0,1,0,0-.964Z",
    transform: "translate(-385.469 -345.211)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M76.765,459.8h-.482a.482.482,0,0,0,0,.964h.482a.482.482,0,1,0,0-.964Z",
    transform: "translate(-71.464 -433.775)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M119.431,459.8h-.482a.482.482,0,1,0,0,.964h.482a.482.482,0,1,0,0-.964Z",
    transform: "translate(-111.72 -433.775)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M162.1,459.8h-.482a.482.482,0,1,0,0,.964h.482a.482.482,0,0,0,0-.964Z",
    transform: "translate(-151.978 -433.775)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M204.765,459.8h-.482a.482.482,0,1,0,0,.964h.482a.482.482,0,0,0,0-.964Z",
    transform: "translate(-192.234 -433.775)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M247.431,459.8h-.482a.482.482,0,0,0,0,.964h.482a.482.482,0,0,0,0-.964Z",
    transform: "translate(-232.491 -433.775)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M290.1,459.8h-.482a.482.482,0,0,0,0,.964h.482a.482.482,0,0,0,0-.964Z",
    transform: "translate(-272.748 -433.775)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M332.765,459.8h-.482a.482.482,0,0,0,0,.964h.482a.482.482,0,0,0,0-.964Z",
    transform: "translate(-313.006 -433.775)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M375.431,459.8h-.482a.482.482,0,1,0,0,.964h.482a.482.482,0,0,0,0-.964Z",
    transform: "translate(-353.262 -433.775)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M418.1,459.8h-.482a.482.482,0,1,0,0,.964h.482a.482.482,0,1,0,0-.964Z",
    transform: "translate(-393.52 -433.775)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.211,459.8h-1.928a.455.455,0,0,0-.482.482v1.928a.482.482,0,1,0,.964,0v-1.446h1.446a.482.482,0,1,0,0-.964Z",
    transform: "translate(-433.777 -433.775)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M417.616,34.1h.482a.482.482,0,0,0,0-.964h-.482a.482.482,0,1,0,0,.964Z",
    transform: "translate(-393.52 -31.206)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M374.949,34.1h.482a.482.482,0,0,0,0-.964h-.482a.482.482,0,0,0,0,.964Z",
    transform: "translate(-353.262 -31.206)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M332.282,34.1h.482a.482.482,0,0,0,0-.964h-.482a.482.482,0,0,0,0,.964Z",
    transform: "translate(-313.005 -31.206)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M289.616,34.1h.482a.482.482,0,0,0,0-.964h-.482a.482.482,0,1,0,0,.964Z",
    transform: "translate(-272.748 -31.206)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M246.949,34.1h.482a.482.482,0,0,0,0-.964h-.482a.482.482,0,0,0,0,.964Z",
    transform: "translate(-232.491 -31.206)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M204.282,34.1h.482a.482.482,0,0,0,0-.964h-.482a.482.482,0,0,0,0,.964Z",
    transform: "translate(-192.233 -31.206)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M161.616,34.1h.482a.482.482,0,1,0,0-.964h-.482a.482.482,0,0,0,0,.964Z",
    transform: "translate(-151.978 -31.206)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M68.231,34.1a.482.482,0,0,0,0-.964h-.482a.482.482,0,0,0,0,.964Z",
    transform: "translate(-63.411 -31.206)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M460.282,1.893h1.928a.455.455,0,0,0,.482-.482.455.455,0,0,0-.482-.482h-1.446V-.517A.455.455,0,0,0,460.282-1a.455.455,0,0,0-.482.482V1.411A.455.455,0,0,0,460.282,1.893Z",
    transform: "translate(-433.776 0.999)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.41-1a.455.455,0,0,0-.482.482V.928H-.518A.455.455,0,0,0-1,1.41a.455.455,0,0,0,.482.482H1.41a.455.455,0,0,0,.482-.482V-.518A.455.455,0,0,0,1.41-1Z",
    transform: "translate(1 1)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.616,75.8a.455.455,0,0,0-.482.482v.482a.482.482,0,1,0,.964,0v-.482A.455.455,0,0,0,33.616,75.8Z",
    transform: "translate(-31.206 -71.462)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.616,118.467a.455.455,0,0,0-.482.482v.482a.482.482,0,0,0,.964,0v-.482A.455.455,0,0,0,33.616,118.467Z",
    transform: "translate(-31.206 -111.72)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.616,161.133a.455.455,0,0,0-.482.482v.482a.482.482,0,0,0,.964,0v-.482A.455.455,0,0,0,33.616,161.133Z",
    transform: "translate(-31.206 -151.977)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.616,203.8a.455.455,0,0,0-.482.482v.482a.482.482,0,0,0,.964,0v-.482A.455.455,0,0,0,33.616,203.8Z",
    transform: "translate(-31.206 -192.233)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.616,246.467a.455.455,0,0,0-.482.482v.482a.482.482,0,0,0,.964,0v-.482A.455.455,0,0,0,33.616,246.467Z",
    transform: "translate(-31.206 -232.491)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.616,289.133a.455.455,0,0,0-.482.482v.482a.482.482,0,0,0,.964,0v-.482A.455.455,0,0,0,33.616,289.133Z",
    transform: "translate(-31.206 -272.747)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.616,331.8a.455.455,0,0,0-.482.482v.482a.482.482,0,0,0,.964,0v-.482A.455.455,0,0,0,33.616,331.8Z",
    transform: "translate(-31.206 -313.005)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.616,374.467a.455.455,0,0,0-.482.482v.482a.482.482,0,1,0,.964,0v-.482A.455.455,0,0,0,33.616,374.467Z",
    transform: "translate(-31.206 -353.262)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.616,417.133a.455.455,0,0,0-.482.482v.482a.482.482,0,0,0,.964,0v-.482A.455.455,0,0,0,33.616,417.133Z",
    transform: "translate(-31.206 -393.519)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M460.282,68.713a.455.455,0,0,0,.482-.482v-.482a.482.482,0,0,0-.964,0v.482A.455.455,0,0,0,460.282,68.713Z",
    transform: "translate(-433.776 -63.411)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M460.282,111.38a.455.455,0,0,0,.482-.482v-.482a.482.482,0,1,0-.964,0v.482A.455.455,0,0,0,460.282,111.38Z",
    transform: "translate(-433.776 -103.669)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M460.282,154.047a.455.455,0,0,0,.482-.482v-.482a.482.482,0,1,0-.964,0v.482A.455.455,0,0,0,460.282,154.047Z",
    transform: "translate(-433.776 -143.926)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M460.282,196.713a.455.455,0,0,0,.482-.482v-.482a.482.482,0,1,0-.964,0v.482A.455.455,0,0,0,460.282,196.713Z",
    transform: "translate(-433.776 -184.183)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M460.282,239.38a.455.455,0,0,0,.482-.482v-.482a.482.482,0,1,0-.964,0v.482A.455.455,0,0,0,460.282,239.38Z",
    transform: "translate(-433.776 -224.439)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M460.282,282.047a.455.455,0,0,0,.482-.482v-.482a.482.482,0,1,0-.964,0v.482A.455.455,0,0,0,460.282,282.047Z",
    transform: "translate(-433.776 -264.697)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M460.282,324.713a.455.455,0,0,0,.482-.482v-.482a.482.482,0,1,0-.964,0v.482A.455.455,0,0,0,460.282,324.713Z",
    transform: "translate(-433.776 -304.953)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M460.282,418.58a.455.455,0,0,0,.482-.482v-.482a.482.482,0,1,0-.964,0v.482A.455.455,0,0,0,460.282,418.58Z",
    transform: "translate(-433.776 -393.52)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.41,459.8H-.518a.455.455,0,0,0-.482.482.455.455,0,0,0,.482.482H.928v1.446a.455.455,0,0,0,.482.482.455.455,0,0,0,.482-.482v-1.928A.455.455,0,0,0,1.41,459.8Z",
    transform: "translate(1 -433.775)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoSurfaceHabitable);
export default __webpack_public_path__ + "static/media/picto_surface_habitable.9a4e9943.svg";
export { ForwardRef as ReactComponent };